import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function AccesoYUsoDeLaPaginaWeb() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h5 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>ACCESO Y USO DE LA PÁGINA WEB</h5>
          <br></br>
          <ol style={{ listStyleType: 'lower-alpha', paddingLeft: '20px' }}>
            <li>
              <p>
                El Usuario debe ingresar a la página web oficial de la Parking a través de la siguiente dirección: <a href="https://parking.net.co" target="_blank" rel="noopener noreferrer">https://parking.net.co</a>, desde cualquier navegador con conexión a internet. Mediante la página web el Usuario podrá conocer los servicios ofrecidos por Parking.
              </p>
            </li>
          </ol>
        </Col>
      </Row>
    </Container>
  );
}